var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15C9.38446 15 10.7379 14.5895 11.889 13.8203C13.0401 13.0511 13.9373 11.9579 14.4672 10.6788C14.997 9.39973 15.1356 7.99225 14.8655 6.63439C14.5954 5.27652 13.9286 4.02925 12.9497 3.05028C11.9707 2.07131 10.7235 1.4046 9.36561 1.13451C8.00775 0.864412 6.60032 1.00303 5.32123 1.53284C4.04215 2.06265 2.94883 2.95986 2.17966 4.111C1.41049 5.26215 1 6.61553 1 8C1 9.85652 1.73747 11.637 3.05023 12.9498C4.36298 14.2625 6.14348 15 8 15Z",
    stroke: "#097E52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 11.2666L9.4001 7.99997L6.6001 4.73328",
    stroke: "#097E52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.ac1235b6fbdb634c2c4e38e3cb1e6372.svg";
export { ForwardRef as ReactComponent };